import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useIsMobileWidth } from '@omnea-app/fe-browser-utils/useDetectDevice'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'

export const useIsBeamerEnabled = () => {
  const { SHOW_BEAMER } = useFeatureFlags()
  const userData = useAuthenticatedUser()
  const isMobile = useIsMobileWidth()
  return SHOW_BEAMER && userData.isFullyAuthenticated && !userData.user?.isSupplier && !isMobile
}
